import React from 'react';
import { Link } from 'react-router-dom';
import consultationBg from '../assests/img/consultation-bg.jpg';

function ConsultationCTA() {
  return (
    <section
      className="ma-consultation"
      aria-labelledby="consultation-title"
      style={{ backgroundImage: `url(${consultationBg})` }}
    >
      <div className="ma-consultation-overlay" aria-hidden="true" />

      <div className="ma-container ma-consultation-inner">
        <p className="ma-consultation-subtitle">
          {'// Drop us a line! We are here to answer your questions 24/7'}
        </p>
        <h2 id="consultation-title" className="ma-consultation-title">
          NEED A CONSULTATION?
        </h2>
        <Link to="/contact" className="ma-consultation-btn">
          CONTACT US
        </Link>
      </div>
    </section>
  );
}

export default ConsultationCTA;
